import React from 'react'
import { createRoot } from 'react-dom/client'
import ProductTile from "./ProductTile.jsx"

const appAttribute = 'product-tile'

document.addEventListener('DOMContentLoaded', () => {
  const productTiles = document.querySelectorAll(`[${appAttribute}]:empty`)
  productTiles.forEach((tile) => setupProductTile(tile))
})

const setupProductTile = (productTileEl) => {
  if(typeof productTileEl != 'undefined') {
    const variant = JSON.parse(productTileEl.getAttribute('variant'))
    const product = JSON.parse(productTileEl.getAttribute('product'))
    const openAttr = productTileEl.getAttribute('open')
    const open = openAttr ? (openAttr == true || openAttr == 'true') : false
    const customAttr = JSON.parse(productTileEl.getAttribute('custom-attributes'))
    const customAttributes = customAttr ? JSON.parse(customAttr) : null
    const root = createRoot(productTileEl)
    root.render(<ProductTile variant={variant} product={product} open={open} customAttributes={customAttributes} />)
  }
}

window.setupATile = setupProductTile

window.setupProductTiles = (tiles) => {
  tiles.forEach((tile) => setupProductTile(tile))
}